const genFranchiseOptions = (statsConfig, label) => {
    const franchises = statsConfig.franchiseData
        .sort((a, b) => {
            if (a.lastSeason && !b.lastSeason) {
                return 1;
            }
            if (!a.lastSeason && b.lastSeason) {
                return -1;
            }

            return a.fullName.localeCompare(b.fullName);
        })
        .map((franchise) => ({
            active: !franchise.lastSeason,
            value: `franchise.${franchise.id}`,
            label: franchise.fullName,
            key: franchise.id,
        }));

    return [{ value: '', label }, ...franchises];
};

export default genFranchiseOptions;
